import { api, handleError } from "./baseApi";

export async function createCoupan(payload) {
  try {
    const { data } = await api.post("/coupan", payload);
    return data;
  } catch (error) {
    return handleError(error, "Failed to create coupan");
  }
}

export async function updateCoupan(coupanId, payload) {
  try {
    const { data } = await api.put(`/coupan/${coupanId}`, payload);
    return data;
  } catch (error) {
    return handleError(error, "Failed to update coupan");
  }
}

export async function deleteCoupan(coupanId) {
  try {
    const { data } = await api.delete(`/coupan/${coupanId}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to delete coupan");
  }
}

export async function getCoupanById(coupanId) {
  try {
    const { data } = await api.get(`/coupan/${coupanId}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch coupan");
  }
}

export async function getCoupanByCode(coupanCode) {
  try {
    const { data } = await api.get(`/coupan/coupan-code/${coupanCode}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch coupan by code");
  }
}

export async function checkCoupanValidity(coupanCode) {
  try {
    const { data } = await api.get(`/coupan/check-validity/${coupanCode}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to check coupan validity");
  }
}

export async function getAllCoupans(filters = {}) {
  try {
    const params = { ...filters };
    Object.keys(params).forEach((key) => {
      if (params[key] === "" || params[key] == null) {
        delete params[key];
      }
    });

    const { data } = await api.get("/coupan", { params });
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch coupans");
  }
}

